<template>
  <div>
    <Menu
      mode="horizontal"
      :active-name="menu_name"
      @on-select="selectMenu"
      style="width: 100%"
    >
      <div v-for="(v, k) in menus" :key="k" style="display: inline-block" v-auth="v.auth">
        <MenuItem
          :name="v.name"
          @click="v.onClick"
          v-show="v.show === true ? false : true"
        >
          <Badge
            :overflow-count="10000000"
            v-if="v.badge && v.badge.count"
            :count="v.badge.count"
            :offset="[18, -3]"
          >
            {{ v.label }}
          </Badge>
          <span v-if="!(v.badge && v.badge.count)">
            {{ v.label }}
          </span>
        </MenuItem>
      </div>
    </Menu>
    <div style="margin-top: 20px">
      <Space>
        <span>月度固定服务费：</span>
        <Input
          placeholder="请填写金额"
          type="number"
          v-model="totalFeeAmount"
          style="width: 30%"
        />
      </Space>
      <h4 style="margin-top: 10px">分摊维度：</h4>
      <div v-for="(item, index) in sharelist" :key="index">
        <div>
          <span> {{ item.costItemName }}比例：</span>
          <InputNumber
            style="width: 30%; margin: 10px 0 15px 15px; align-items: baseline"
            :max="100"
            v-model="item.allocationRatio"
            :formatter="(value) => `${value}%`"
            :parser="(value) => value.replace('%', '')"
          />
        </div>
      </div>
      <Button type="primary" @click="onsave('formInline')">保存</Button>
    </div>
  </div>
  <!--
<div class="divCaculateResultDisplay">
    <div class="Top">
      <p class="title"><span style="color: red">*</span> 月固定服务费:</p>
      <div class="input">
        <el-input size="small" type='number' v-model="workflowName" placeholder="请输入"></el-input>
      </div>
    </div>
    <div class="divNotAllowCaculateResult">
      <el-table
        border
        :data="tableData"
        class="tb-edit"
        style="width: 100%"
        @cell-click="getCell"
        :cell-class-name="tableCellClassName"
        highlight-current-row
      >
        <el-table-column prop="junctionName" label="节点名称" width="" align="center">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.junctionName"
              @blur="handleBlur(scope.row)"
              v-if="
                scope.row.index == tabRowIndex && scope.column.index == tabColumnIndex
              "
              v-focus
            ></el-input>
            <div v-else>
              <span>{{ scope.row.junctionName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="scheduleProportion" label="进度" width="" align="center">
          <template slot-scope="scope">
            <el-input-number
              size="small"
              v-focus
              v-model="scope.row.scheduleProportion"
              v-if="
                scope.row.index == tabRowIndex && scope.column.index == tabColumnIndex
              "
              @change="handleBlur(scope.row)"
            ></el-input-number>
            <div v-else>
              <span>{{ scope.row.scheduleProportion }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="danger" plain @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="addtable"><p class="tian" @click="addRow()">添加</p></div>
    </div>  
  </div>
  -->
</template>
<script>
export default {
  directives: {
    //注册一个局部的自定义指令 v-focus，输入框自动聚焦
    focus: {
      inserted: function (el) {
        el.querySelector("input").focus();
      },
    },
  },
  data() {
    return {
      menu_name: "",
      menus: [
        {
          label: "成本",
          name: "Accountingreport",
          auth: "/admin/Accounting/main",
        },
        {
          label: "科室",
          name: "AccountingList",
          auth: "/admin/Accounting/main",
        },
        {
          label: "核算设置",
          name: "Accountinginstall",
          auth: "/admin/Accounting/main",
        },
      ],
      page: 1,
      tabRowIndex: null, //行角标
      tabColumnIndex: "", //列角标
      remark: "",
      workflowName: "",
      tableData: [],
      action: "",
      id: Number(""),
      deleteIdS: [],
      totalFeeAmount: "",
      sharelist: [],
      customerId: "",
      ruleName: "",
    };
  },
  created() {
    let route = this.$route;
    if (route) {
      this.menu_name = route.name;
    }
    this.info();
    let query = this.$route.query;
    this.action = query.action;
    if (query.action === "edit") {
      if (query.kv) {
        this.id = query.kv;
        this.initData(query.kv);
      }
    }
  },
  methods: {
    selectMenu(name) {
      if (this.menu_name !== name) {
        setTimeout(() => {
          this.$destroy();
        }, 100);
        $utils.url.push({ name: name, params: { refresh: true } });
      }
    },
    async initData(id) {
      if (id) {
        let res = await $utils.api.load(`/admin/system/schedule/${id}`);
        try {
          if (res) {
            let list = res.data.sysProjectScheduleStateList || [];
            this.workflowName = res.data.workflowName;
            this.remark = res.data.remark;
            this.tableData = list;
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    async info() {
      let res = await $utils.api.load(
        "/admin/system/costAllocationRules/getCustomerRule",
        {},
        "get"
      );
      if (res.code == 200) {
        let data = res.data;
        this.totalFeeAmount = data.totalFeeAmount;
        this.sharelist = data.items.map((item) => {
          return {
            ...item,
            allocationRatio: item.allocationRatio * 100, // 将小数转换为百分比
          };
        });
        this.id = data.id;
        this.customerId = data.customerId;
        this.ruleName = data.ruleName;
      }
    },
    addRow() {
      const hasFullProgress = this.tableData.some(
        (item) => item.scheduleProportion === 100
      );
      if (hasFullProgress) {
        $utils.toast.success("进度已到100%,请勿添加!");
        return;
      }
      this.tableData.push({
        junctionName: "请填写",
        scheduleProportion: 100,
      });
    },
    getCell(row, column, cell, event) {
      this.tabRowIndex = row.index;
      this.tabColumnIndex = column.index;
    },
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      //注意这里是解构
      //利用单元格的 className 的回调方法，给行列索引赋值
      row.index = rowIndex;
      column.index = columnIndex;
    },
    handleBlur(row) {
      this.tabRowIndex = null;
      this.tabColumnIndex = null;
    },
    handleDelete(index, row) {
      this.deleteIdS.push(row.id);
      const indexToRemove = index;
      if (indexToRemove > -1) {
        this.tableData.splice(indexToRemove, 1);
      }
    },
    async onsave() {
      if (this.totalFeeAmount == "") {
        $utils.toast.success("请填写月度固定服务费!");
        return;
      }
      let d = {
        totalFeeAmount: this.totalFeeAmount,
        items: this.sharelist,
        id: this.id,
        customerId: this.customerId,
        ruleName: this.ruleName,
      };
      console.log(d);
      let res = await $utils.api.load(
        "/admin/system/costAllocationRules/update",
        d,
        "POST"
      );
      if (res.code == 200) {
        $utils.toast.success("保存成功!");
        // $utils.url.go(-1);
      }
    },
  },
};
</script>
<style scoped>
.addtable {
  width: 100%;
  border: 1px solid #ebeef5;
  border-top: none;
  text-align: center;
  color: #2d41ef;
}
.tian {
  line-height: 40px;
  cursor: pointer;
}
.divNotAllowCaculateResult {
  margin: 10px 0;
}
.Top {
  display: flex;
  margin: 5px 0;
}
.title {
  font-weight: normal;
  width: 7%;
  margin-right: 10px;
  font-size: 14px;
  line-height: 2.5;
}
.input {
  width: 30%;
}
</style>
